module.exports = __webpack_public_path__ + "static/media/newspaper.4151ee88.png";